import { APP_BOOTSTRAP_LISTENER, inject, Provider } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';

export const provideTranslations = (): Provider[] => {
  return [
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: () => {
        const translocoService = inject(TranslocoService);

        const defaultLang = translocoService.getDefaultLang();
        translocoService.setActiveLang(defaultLang);

        return () => firstValueFrom(translocoService.load(defaultLang));
      }
    }
  ];
};
